"use client";

import { useI18n } from "@/lib/i18n/I18nProvider";

/**
 * MyTasksMock — список задач на утверждение
 */

export function MyTasksMock() {
  const { t } = useI18n();

  const tasks = [
    {
      id: "PR-2026-0345",
      typeKey: "payment",
      type: t("landing.mocks.myTasks.typePayment") || "Платёж",
      amount: "₽850,000",
      counterpartyKey: "stroysnab",
      counterparty: t("landing.mocks.myTasks.counterpartyStroysnab") || "ООО СтройСнаб",
      urgencyKey: "urgent",
      urgency: t("landing.mocks.myTasks.urgencyUrgent") || "Срочно",
      initiator: "И.О.",
    },
    {
      id: "PO-2026-0012",
      typeKey: "procurement",
      type: t("landing.mocks.myTasks.typeProcurement") || "Закупка",
      amount: "₽124,000",
      counterpartyKey: "hoztorg",
      counterparty: t("landing.mocks.myTasks.counterpartyHoztorg") || "ООО Хозторг",
      urgencyKey: "standard",
      urgency: t("landing.mocks.myTasks.urgencyStandard") || "Стандарт",
      initiator: "П.М.",
    },
    {
      id: "PR-2026-0346",
      typeKey: "payment",
      type: t("landing.mocks.myTasks.typePayment") || "Платёж",
      amount: "₽380,500",
      counterpartyKey: "voda-svet",
      counterparty: t("landing.mocks.myTasks.counterpartyVodaSvet") || "АО Вода-Свет",
      urgencyKey: "standard",
      urgency: t("landing.mocks.myTasks.urgencyStandard") || "Стандарт",
      initiator: "А.В.",
    },
  ];

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-50 to-white px-6 py-4 border-b border-slate-200">
        <h3 className="text-sm font-bold text-slate-900">
          {t("landing.mocks.myTasks.title") || "Мои задачи на согласование"}
        </h3>
        <p className="text-xs text-slate-500 mt-1">
          {t("landing.mocks.myTasks.subtitle") || "3 документа ожидают вашего решения"}
        </p>
      </div>

      {/* Task list */}
      <div className="divide-y divide-slate-200">
        {tasks.map((task, i) => (
          <div
            key={i}
            className="px-6 py-4 hover:bg-slate-50/50 transition-colors cursor-pointer"
          >
            <div className="flex items-center gap-4">
              {/* Avatar / initiator */}
              <div className="w-8 h-8 rounded-full bg-keiro-green/10 flex items-center justify-center flex-shrink-0">
                <span className="text-xs font-bold text-keiro-green">
                  {task.initiator}
                </span>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <p className="text-sm font-semibold text-slate-900">
                      {task.id}
                    </p>
                    <p className="text-xs text-slate-600 mt-1">
                      {task.counterparty}
                    </p>
                  </div>

                  {/* Amount */}
                  <div className="text-right flex-shrink-0">
                    <p className="text-sm font-mono font-bold text-slate-900">
                      {task.amount}
                    </p>
                    <p className="text-xs text-slate-500 mt-1">{task.type}</p>
                  </div>
                </div>
              </div>

              {/* Urgency chip */}
              <div className="flex-shrink-0">
                <span className={`text-xs px-2.5 py-1.5 rounded-full font-semibold inline-block ${
                  task.urgencyKey === "urgent"
                    ? "bg-red-50 text-red-700"
                    : "bg-slate-100 text-slate-700"
                }`}>
                  {task.urgency}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Demo label */}
      <div className="bg-slate-50 border-t border-slate-200 px-6 py-2 text-center">
        <p className="text-xs text-slate-500">
          {t("landing.mocks.myTasks.demoLabel") || "Демо-режим · реальный UI продукта"}
        </p>
      </div>
    </div>
  );
}
